/* Tysk katalog for locale-reports-labels-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'rep.zeroHidden': 'Die Konten haben in diesem Zeitraum einen Nullsaldo. Anzeige über Filter.',
  'rep.showZero': 'Konten mit Nullsaldo anzeigen',
  'rep.group.tax': 'ERTRAGSTEUERN',
  'rep.trial.titleHelp': 'Die Summen- und Saldenliste führt alle Konten des Kontenplans mit Saldo für den gewählten Zeitraum auf. Tippe auf eine Kontozeile, um die auf dem Konto gebuchten Belege zu sehen.',
  'rep.trial.viewHelp': 'Die Summen- und Saldenliste zeigt standardmäßig nur aktive Konten — Konten mit Saldo oder Bewegung. „Auch inaktive Konten anzeigen“ nimmt den restlichen Kontenplan dazu, und „Nur Konten mit Bewegung anzeigen“ setzt voraus, dass auf dem Konto im Zeitraum gebucht wurde. „Anzeigen als“ legt fest, ob Beträge in Kronen und Øre, ganzen Kronen oder ganzen Tausend angezeigt werden.',
  'rep.trial.empty': 'Keine gebuchten Salden für den gewählten Zeitraum.',
  'rep.trial.oneSupplier': '1 Lieferant',
  'rep.trial.supplierCount': '{n} Lieferanten',
  'rep.trial.oneCustomer': '1 Kunde',
  'rep.trial.customerCount': '{n} Kunden',
  'rep.trial.oneOpenCustomerItem': '1 offener Posten',
  'rep.trial.openCustomerItems': '{n} offene Posten',
  'rep.trial.customerDifference': 'Sonstige Buchungen / Abstimmungsdifferenz',
  'rep.trial.noCustomerBalances': 'Keine Kundensalden in der gewählten Ansicht.',
  'rep.trial.oneOpenSupplierItem': '1 offener Posten',
  'rep.trial.openSupplierItems': '{n} offene Posten',
  'rep.trial.supplierDifference': 'Sonstige Buchungen / Abstimmungsdifferenz',
  'rep.trial.noSupplierBalances': 'Keine Lieferantensalden in der gewählten Ansicht.',
  'rep.trial.exportTitle': 'Summen- und Saldenliste: {column}',
  'rep.group.assets': 'AKTIVA',
  'rep.group.equityLiabilities': 'EIGENKAPITAL / VERBINDLICHKEITEN',
  'rep.group.operatingIncome': 'BETRIEBLICHE ERTRÄGE',
  'rep.group.operatingCosts': 'BETRIEBLICHE AUFWENDUNGEN',
  'rep.groupTotal': 'Summe {group}',
  'rep.balance.opening': 'Anfangsbestand',
  'rep.balance.movement': 'Veränderung',
  'rep.balance.closing': 'Endbestand',
  'rep.showAs.withDecimals': 'Kronen und Øre',
  'rep.showAs.whole': 'Ganze Kronen',
  'rep.showAs.thousands': 'Ganze Tausend',
  'rep.result.titleHelp': 'Die Gewinn- und Verlustrechnung zeigt die Erträge und Aufwendungen im Zeitraum und was als Ergebnis übrig bleibt. Öffne einen Abschnitt, um die Konten hinter den Zahlen zu sehen, und tippe auf eine Kontozeile, um die dort gebuchten Belege zu sehen.',
  'rep.result.subtitle': 'Beginne mit der Zusammenfassung und öffne bei Bedarf die Kontodetails.',
  'rep.result.income': 'Betriebliche Erträge',
  'rep.result.costs': 'Betriebliche Aufwendungen',
  'rep.result.finance': 'Finanzergebnis',
  'rep.result.beforeTax': 'Ergebnis vor Steuern',
  'rep.result.noLines': 'Noch keine Aktivität auf diesen Konten.',
  'rep.total': 'Summe',
  'rep.showDetails': 'Details anzeigen',
  'rep.hideDetails': 'Details ausblenden',
  'rep.shareOfLargest': '{pct} % des größten Postens',
  'rep.showVouchersFor': 'Alle Belege auf {account} anzeigen',
  'rep.period.otherYear': 'Zeigt Zahlen für das Geschäftsjahr {year}.',
  'rep.period.singleYear': 'Der Zeitraum erstreckt sich über zwei Geschäftsjahre. Berichte werden je Geschäftsjahr mit dem Anfangsbestand ab Jahresbeginn berechnet, wähle daher einen Zeitraum innerhalb eines Jahres.',
  'rep.export.busy': 'Wird exportiert...',
  'rep.export.downloaded': '{format} heruntergeladen',
  'rep.export.failed': 'Der Bericht konnte nicht exportiert werden.',
  'rep.export.pdfUnavailable': 'Das Berichts-PDF ist nicht mit dem Backend verbunden.',
  'rep.export.year': 'Jahr',
  'rep.export.period': 'Zeitraum',
  'rep.export.summary': 'Zusammenfassung',
  'rep.export.item': 'Posten',
  'rep.export.amount': 'Betrag',
  'rep.accountHelp.receivables': 'Forderungen aus Lieferungen sind Beträge, die Kunden dir für noch nicht bezahlte Rechnungen schulden.',
  'rep.accountHelp.bank': 'Bankguthaben zeigt das Geld auf dem Geschäftskonto.',
  'rep.accountHelp.payables': 'Verbindlichkeiten aus Lieferungen sind Rechnungen und Käufe, die du Lieferanten schuldest.',
  'rep.accountHelp.outputVat': 'Ausgangs-MwSt. ist die Mehrwertsteuer, die du beim Verkauf eingenommen hast.',
  'rep.accountHelp.inputVat': 'Vorsteuer ist die Mehrwertsteuer, die du beim Einkauf gezahlt hast und normalerweise abziehen kannst.',
  'rep.accountHelp.vatSettlement': 'Das MwSt.-Verrechnungskonto zeigt die Netto-MwSt., die du schuldest oder zugute hast.',
  'rep.accountHelp.vatableSales': 'Umsatzerlöse mit MwSt.-Pflicht zeigen den regulären Verkauf, bei dem Ausgangs-MwSt. berechnet wird.',
  'rep.accountHelp.group.asset': 'Aktivkonto: Werte, die das Unternehmen besitzt oder zugute hat.',
  'rep.accountHelp.group.equityLiability': 'Eigenkapital oder Verbindlichkeiten: Finanzierung, geschuldete Beträge und Verrechnungsposten.',
  'rep.accountHelp.group.income': 'Ertragskonto: Umsätze und sonstige Erträge des Unternehmens.',
  'rep.accountHelp.group.goods': 'Materialaufwand: Kosten für Waren, Rohstoffe oder den Wiederverkauf.',
  'rep.accountHelp.group.payroll': 'Lohnaufwand: Löhne, Urlaubsgeld und personalbezogene Leistungen.',
  'rep.accountHelp.group.operating': 'Betriebsaufwand: Kosten für den Betrieb des Unternehmens.',
  'rep.accountHelp.group.finance': 'Finanz- oder Steuerkonto: Zinsen, Finanzposten oder Steueraufwand.',
  'rep.accountHelp.other': 'Konto {account} im Kontenplan.',
  'rep.accountHelp.openVouchers': 'Tippe auf die Kontozeile, um alle auf diesem Konto gebuchten Belege zu sehen.',
  'rep.dimensions.title': 'Projekt und Abteilung',
  'rep.dimensions.help': 'Filtere den Bericht, ohne die Quelldaten zu ändern. Der gesamte Beleg bleibt erhalten, einschließlich der Gegenbuchungen.',
  'rep.dimensions.project': 'Projekt',
  'rep.dimensions.department': 'Abteilung',
  'rep.dimensions.all': 'Alle',
  'rep.dimensions.unassigned': 'Nicht zugeordnet',
  'rep.incompleteBasisTitle': 'Die Buchhaltungsgrundlage ist unvollständig',
  'rep.incompleteBasisText': 'Der Bericht wird nicht als vollständig angezeigt, weil die Journalabdeckung oder die erforderliche Anfangsgrundlage nicht dokumentiert ist. Die verfügbaren Daten bleiben zur Prüfung erhalten.',
  'rep.importedBasisTitle': 'Importierte Kontenstatistik.',
  'rep.importedBasisText': 'Die Zahlen stammen aus geprüfter importierter Kontenstatistik, nicht aus Journalbuchungen in Plumme. Sie sind nicht zertifiziert und können nicht für Einreichungen, Zahlungsfreigaben oder den Jahresabschluss verwendet werden.',
  'rep.importedBasisExport': 'Geprüfte importierte Kontenstatistik; nicht journalvollständig oder zertifiziert.',
});
